import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label, MultiDataSet, SingleDataSet } from 'ng2-charts';
import { AuthService } from '../services/auth.service';
import { MetricsService } from '../services/metrics.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  nativeLanguageOptions: string[];
  nativeSelected: string;
  totalRecording;
  todayRecording;
  lineChartArray = [];
  douhgnutChartArray = [];
  pieChartArray = [];
  currentRoute: string;

  // line chart
  public lineChartData: ChartDataSets[] = [
    {
      data: this.lineChartArray,
      label: 'Accent Data',
    },
  ];
  public lineChartLabels: Label[] = [
    'Hausa',
    'Yoruba',
    'Igbo',
    'Fulfulde',
    'Efik-Ibibio',
    'Kanuri',
    'Tiv',
    'Edo',
    'Igala',
    'Nupe',
    'Izon',
    'Others',
  ];
  public lineChartOptions = {
    responsive: true,
  };
  public lineChartColors: Color[] = [
    {
      borderColor: '#5A67D8',
      // backgroundColor: 'none',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  // Doughnut
  public doughnutChartLabels: Label[] = [
    '< 4',
    '4 - 12',
    '12 - 20',
    '20 - 30',
    '> 30',
  ];
  public donutColors = [
    {
      backgroundColor: ['#FF4C61', '#6F52ED', '#FFB800', '#33D69F', '#5A67D8'],
    },
  ];
  public options: any = {
    legend: { position: 'right' },
    labels: {
      render: 'label',
    },
  };
  public doughnutChartData: MultiDataSet = [this.douhgnutChartArray];
  public doughnutChartType: ChartType = 'doughnut';

  //barchat
  public barChartOptions: ChartOptions = {
    responsive: true,
  };
  public barChartLabels: Label[] = ['Nigerian', 'Others'];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barchartColors = [
    {
      backgroundColor: ['#5A67D8', '#5A67D8'],
    },
  ];

  public barChartData: ChartDataSets[] = [
    { data: [65, 20, 0], label: 'Nationality' },
  ];

  // Pie
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: Label[] = [
    'Yoruba',
    'Efik-Ibibio',
    'Igbo',
    'Hausa',
    'Western',
    'Others',
  ];
  public pieChartData: SingleDataSet = this.pieChartArray;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [
        '#FF4C61',
        '#6F52ED',
        '#FFB800',
        '#33D69F',
        '#5A67D8',
        '#5A67J8',
      ],
    },
  ];

  constructor(
    public authService: AuthService,
    private metric: MetricsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.nativeLanguageOptions = [
      'all',
      'Hausa',
      'Yoruba',
      'Igbo',
      'Fulfulde',
      'Efik-Ibibio',
      'Kanuri',
      'Tiv',
      'Edo',
      'Igala',
      'Nupe',
      'Izon',
      'Others',
    ];

    //total recordings
    this.metric.getTotalRecording().subscribe((recordings: any) => {
      this.totalRecording = recordings[0].count;
    });

    //today's recording
    this.metric.getTodaysRecord().subscribe((records: any) => {
      const data = [];
      records
        .filter((recs) => {
          const today = new Date().toDateString();
          const records =
            recs.createdAt &&
            new Date(recs.createdAt.seconds * 1000).toDateString();
          return records === today;
        })
        .map((recs) => data.push(recs));
      this.todayRecording = data.length;
    });

    //line chart metric
    this.metric.getTodaysRecord().subscribe((recordings: any) => {
      const data = [];
      const labels = [
        'Hausa',
        'Yoruba',
        'Igbo',
        'Fulfulde',
        'Efik-Ibibio',
        'Kanuri',
        'Tiv',
        'Edo',
        'Igala',
        'Nupe',
        'Izon',
        'Others',
      ];

      labels.map((label) => {
        const languageCount = recordings.filter(
          (record) => record.nativeLanguage === label
        ).length;
        data.push(languageCount);
      });
      this.lineChartArray.length = 0;
      this.lineChartArray.push(...data);
    });

    //doughnnut chart metric
    this.metric.getTodaysRecord().subscribe((recordings: any) => {
      const data = [];
      const labels = ['< 4', '4 - 12', '12 - 20', '20 - 30', '> 30'];

      labels.map((label) => {
        const languageCount = recordings.filter(
          (record) => record.ageOfEnglish === label
        ).length;
        data.push(languageCount);
      });
      this.douhgnutChartArray.length = 0;
      this.douhgnutChartArray.push(...data);
    });

    //pie chart metric
    this.metric.getTodaysRecord().subscribe((recordings: any) => {
      const data = [];
      const labels = [
        'Yoruba',
        'Efik-Ibibio',
        'Igbo',
        'Hausa',
        'Western',
        'Others',
      ];

      labels.map((label) => {
        const languageCount = recordings.filter(
          (record) => record.fluentLanguage === label
        ).length;
        data.push(languageCount);
      });
      this.pieChartArray.length = 0;
      this.pieChartArray.push(...data);
    });
  }

  logOut() {
    this.authService.logout();
  }

  onChangeOtherLang() {
    console.log(this.nativeSelected);
    switch (this.nativeSelected) {
      case 'all':
        this.getAllRecords();
        break;
      case 'Hausa':
        this.getSingleRecord('Hausa');
        break;
      case 'Yoruba':
        this.getSingleRecord('Yoruba');
        break;

      default:
        this.getAllRecords();
    }
  }

  getAllRecords() {
    this.metric.getTodaysRecord().subscribe((recordings: any) => {
      const data = [];
      const labels = [
        'Hausa',
        'Yoruba',
        'Igbo',
        'Fulfulde',
        'Efik-Ibibio',
        'Kanuri',
        'Tiv',
        'Edo',
        'Igala',
        'Nupe',
        'Izon',
        'Others',
      ];

      labels.map((label) => {
        const languageCount = recordings.filter(
          (record) => record.nativeLanguage === label
        ).length;
        data.push(languageCount);
      });
      this.lineChartArray.length = 0;
      this.lineChartArray.push(...data);
    });
  }

  getSingleRecord(language: string) {
    this.metric.getTodaysRecord().subscribe((recordings: any) => {
      const data = [];
      const labels = [language];

      labels.map((label) => {
        const languageCount = recordings.filter(
          (record) => record.nativeLanguage === label
        ).length;
        data.push(languageCount);
      });
      this.lineChartArray.length = 0;
      this.lineChartArray.push(...data);
    });
  }
}
